import { NAME } from "./constants";

export const SET_USER_ACCOUNT = `${NAME}/SET_USER_ACCOUNT`;

export const setUserAccount = (userAccount) => ({
    type: SET_USER_ACCOUNT,
    payload: { userAccount },
});
